var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 27.0045C46 25.9207 45.4154 24.9212 44.4708 24.3898L26 14V25L44.1362 29.534C45.0829 29.7707 46 29.0547 46 28.0788V27.0045Z",
    fillOpacity: 0.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 27.0045C4 25.9207 4.58459 24.9212 5.52922 24.3898L24 14V25L5.8638 29.534C4.91708 29.7707 4 29.0547 4 28.0788V27.0045Z",
    fillOpacity: 0.62
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C18.581 8.352 20.5122 5.72937 22.0286 4.3476C23.1674 3.30991 24.8326 3.30991 25.9714 4.3476C27.4878 5.72937 29.419 8.352 30 13C29.5 26 28 35 28 35L32.8284 39.8284C33.5786 40.5786 34 41.596 34 42.6569V43.523C34 44.2304 33.2855 44.7142 32.6286 44.4514L24 41L15.3714 44.4514C14.7145 44.7142 14 44.2304 14 43.523V42.6569C14 41.596 14.4214 40.5786 15.1716 39.8284L20 35C20 35 18.5 26 18 13Z"
  })));
};
export default SvgPlane;